import React from 'react';
import { useLocation, Link } from 'react-router-dom';

export const Breadcrumb = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(x => x);

  return (
    <nav aria-label="breadcrumb" className="breadcrumb-nav">
      <ol className="breadcrumb">
        <li className="breadcrumb-item">
          <Link to="/">Home</Link>
        </li>
        {pathnames.map((name, index) => {
          const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
          const isLast = index === pathnames.length - 1;
          
          return (
            <li key={name} className={`breadcrumb-item${isLast ? ' active' : ''}`}>
              {isLast ? (
                name.replace(/-/g, ' ')
              ) : (
                <Link to={routeTo}>{name.replace(/-/g, ' ')}</Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
